import { motion } from "framer-motion"
import { Zap, Shield, Users } from "lucide-react"

interface AboutSectionProps {
  t: Record<string, any>
}

export function AboutSection({ t }: AboutSectionProps) {
  const stats = [
    { number: "50K+", label: "Active Users", icon: Users },
    { number: "99.9%", label: "Uptime", icon: Shield },
    { number: "24/7", label: "Support", icon: Zap },
  ]

  return (
    <section id="about" className="py-20 px-4 bg-gradient-to-b from-black to-slate-900">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-4xl font-bold text-white mb-6">{t?.about?.title || "About Us"}</h2>
          <p className="text-xl text-gray-300 leading-relaxed">
            {t?.about?.text ||
              "Cardin Taxi offers instant booking, transparent fares, and 24/7 support via a modern app."}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8"
        >
          {stats.map((stat, index) => {
            const Icon = stat.icon
            return (
              <motion.div
                key={index}
                whileHover={{ y: -4 }}
                className="text-center p-6 rounded-lg bg-gradient-to-br from-blue-600/10 to-emerald-600/10 border border-blue-500/20 hover:border-blue-500/40 transition-all duration-300"
              >
                <Icon className="h-8 w-8 text-blue-500 mx-auto mb-3" />
                <p className="text-4xl font-bold text-white mb-2">{stat.number}</p>
                <p className="text-gray-400">{stat.label}</p>
              </motion.div>
            )
          })}
        </motion.div>
      </div>
    </section>
  )
}
